// workOrderTypes.ts — Sprint 11. Palette + filter constants for the
// WorkOrders page. Pure module: no React, no antd imports — safe to
// pull into both the table cell renderers and the modals without
// dragging in the AntD theme tree.
import type { WorkOrder } from '../../types';

/** AntD Tag colour for each WorkOrder.status value. */
export const STATUS_COLORS: Record<string, string> = {
  OPEN:        'blue',
  IN_PROGRESS: 'orange',
  COMPLETED:   'green',
  CANCELLED:   'default',
};

/** AntD Tag colour for each WorkOrder.priority value. */
export const PRIORITY_COLORS: Record<string, string> = {
  LOW:    'default',
  MEDIUM: 'blue',
  HIGH:   'orange',
  URGENT: 'red',
};

/** Status filter chips shown on the page (ALL is the synthetic "no filter" option). */
export const STATUS_FILTERS = ['ALL', 'OPEN', 'IN_PROGRESS', 'COMPLETED', 'CANCELLED'] as const;
export type StatusFilter = typeof STATUS_FILTERS[number];

/** Per-stat-card definition for the summary row at the top of the page. */
export interface StatCardDef {
  label: string;
  count: number;
  color: string;
  bg:    string;
}

/** Re-export the WorkOrder type from a shorter path so the workOrders/*
 *  files don't all have to climb three dirs to find it. */
export type { WorkOrder };
